import React from "react";
import { Box, Loader, Select, Text, Stack, Badge, Switch, Group } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { useGetChecklistMcTemplatesQuery } from "../../openapi";
import {
  setSelectedTemplateNrIdInRedux,
  setShowChecklistTemplatesInDevelopmentInRedux,
} from "../app/routes/checklist/checklistSlice";

const MCTemplateSelectChecklist: React.FC = () => {
  const dispatch = useAppDispatch();

  // State för switch

  const showInDevelopment = useAppSelector((state) => state.checklistReducer.showInDevelopment);

  // Hämta mallar med switch-värde
  const {
    data: templates = [],
    isLoading,
    isSuccess,
    startedTimeStamp,
    fulfilledTimeStamp,
  } = useGetChecklistMcTemplatesQuery(
    { showInDevelopment }, // ← Skickar med parameter
  );

  const selectOptions = React.useMemo(
    () =>
      templates.map((template) => ({
        value: template.id.toString(),
        label: `${template.id} - ${template.name}`,
      })),
    [templates],
  );

  const requestTime =
    isSuccess && startedTimeStamp && fulfilledTimeStamp ? fulfilledTimeStamp - startedTimeStamp : null;
  const lastRequestTimestamp = fulfilledTimeStamp ? new Date(fulfilledTimeStamp).toLocaleString("no-NO") : null;

  return (
    <Box>
      <Group justify="space-between" align="center" mb="xs">
        <Text weight={500}>Velg mal:</Text>
        <Switch
          label="Vis utviklingsmaler"
          checked={showInDevelopment}
          onChange={(e) => dispatch(setShowChecklistTemplatesInDevelopmentInRedux(e.currentTarget.checked))}
          size="sm"
        />
      </Group>

      <Stack>
        {isLoading ? (
          <Loader size="sm" />
        ) : (
          <Select
            placeholder="Ingen mal valgt"
            data={selectOptions}
            searchable
            clearable
            maxDropdownHeight={300}
            leftSection={<i className="fa fa-list" />}
            onChange={(value) => dispatch(setSelectedTemplateNrIdInRedux(value ? Number(value) : null))}
          />
        )}

        {isSuccess && templates.length > 0 && (
          <Stack gap="xs">
            <Badge color="green" leftSection={<i className="fa fa-check" />}>
              Vellykket anrop
            </Badge>
            {requestTime !== null && (
              <Text size="sm" c="dimmed">
                Anropstid: {requestTime.toFixed(2)} ms
              </Text>
            )}
            {lastRequestTimestamp && (
              <Text size="sm" c="dimmed">
                Sist kjørt: {lastRequestTimestamp}
              </Text>
            )}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default MCTemplateSelectChecklist;
